import { render } from "./SuOldAchievementModal.vue?vue&type=template&id=78133fb3"
import script from "./SuOldAchievementModal.vue?vue&type=script&lang=js"
export * from "./SuOldAchievementModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__